/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import StringResources from 'nls/StringResources';
import { clone } from './ClientSideRecommendationUtils';
export default class CompareCardCustomRecommendations {

	/**
	 * Constructor
	 *
	 * @param {Object} options - options
	 * @param {DashboardAPI} options.dashboardApi
	 */
	constructor(options = {}) {
		this.dashboardApi = options.dashboardApi;
	}

	/**
	 * Fetch recommendations
	 *
	 * @param {Object} widgetWrapper - widget wrapper
	 * @param {WidgetAPI} widgetWrapper.widgetApi - widget API instance
	 * @param {WidgetModel} widgetWrapper.widgetModel - widget model instance
	 *
	 * @return Promise
	 */
	fetchRecommendations(widgetWrapper = {}) {
		const widgetApi = widgetWrapper.widgetApi;
		if( !widgetApi ){
			return Promise.resolve([]);
		}
		const widgetModel = widgetWrapper.widgetModel;
		const widgetId = widgetApi.getId();
		const content = this.dashboardApi.getCanvas().getContent(widgetId);
		const visualization = content.getFeature('Visualization');
		const slots = visualization && visualization.getSlots().getMappedSlotList();

		//query recommendations only if there is data item
		if (!visualization || slots.length === 0 || !widgetModel) {
			return Promise.resolve([]);
		}

		const widgetSpec = widgetModel.toJSON();

		const visDefinition = this.dashboardApi.getFeature('VisDefinitions').getById(widgetModel.visId);

		const result = [
			// build yourself
			// - left: copy of the currently selected viz
			// - right: empty placeholder
			{
				staticTitle: StringResources.get('createNewChartToCompareTitle'),
				widgets: [
					{
						spec: this._buildSpec(widgetSpec),
						visDefinition
					},
					// empty item
					{}
				]
			},

			// Duplicate
			{
				staticTitle: StringResources.get('duplicateChartToCompareTitle'),
				widgets: [
					{
						spec: this._buildSpec(widgetSpec),
						visDefinition
					},
					{
						spec: this._buildSpec(widgetSpec),
						visDefinition,
						isHighlighted: true
					}
				]
			}
		];
		return Promise.resolve(result);
	}

	//TODO: Investigate to migrate to Utils
	_buildSpec(widgetSpec = {} ){
		const properties =  [
			{
				id: 'itemAxis.labels.layoutMode',
				value: 'stagger'
			},
			{
				id: 'widget.legend.position',
				value: 'right'
			}
		];
		const widgetSpecCopy = clone(widgetSpec);
		return Object.assign(widgetSpecCopy, { properties, id: undefined });
	}
}



// WEBPACK FOOTER //
// ./src/js/features/compare/recommendations/CompareCardCustomRecommendations.js